jQuery(document).ready(function($){
  
  $(document).on('click','.mobile_menu_wrapper .fa-bars',function(){
    const drawer_wrapper = $(".mobile_menu_drawer");

    drawer_wrapper.show('slide', {direction: 'left'}, 300);
    drawer_wrapper.find('.mobile_nav_menu').show();
    $("body").addClass('mobile_menu_open');
  });

  $(document).on('click','.mobile_menu_drawer_action_wrapper .fa-xmark',function(){
    $(".mobile_menu_drawer").hide('slide', {direction: 'left'}, 300);
    $("body").removeClass('mobile_menu_open');
  });

  $(document).on('click','.mega-menu-wrapper',function(e){
    e.preventDefault();

    const mega_menu_submenu = $(".header-mega-menu-wrapper");
    const id = $(this).attr('data-id');

    if(mega_menu_submenu.attr('data-open') === "false")
    {
      mega_menu_submenu.attr('data-open',"true");
      $(this).find(".fa-solid").removeClass('fa-chevron-down').addClass("fa-chevron-up");
      $(".header-mega-menu-wrapper").slideDown();
      $(".header-mega-menu-content-wrap").hide();
      $(".header-mega-menu-content-wrap[data-id='"+id+"']").show();
    }
    else
    {
      mega_menu_submenu.attr('data-open',"false");
      $(this).find(".fa-solid").removeClass('fa-chevron-up').addClass("fa-chevron-down");
      $(".header-mega-menu-wrapper").slideUp();
      $(".header-mega-menu-content-wrap").hide();
    }

  });

  $(document).on({
    mouseenter: function () {
      $(this).find('ul.mega-menu__list').show();
    },

    mouseleave: function () {
      $(this).find('ul.mega-menu__list').hide();
    }
  }, '.mega-menu-parent-wrapper');

  $(document).on({
    mouseenter: function () {
      $(this).addClass('active-card');
    },

    mouseleave: function () {
      $(this).removeClass('active-card');
    }
  }, '.product-card-inner-wrap, .article-card-inner-wrap');

  $(document).on({
    mouseenter: function () {
      $(this).find('ul.mega-menu-secondary').show();
    },

    mouseleave: function () {
      $(this).find('ul.mega-menu-secondary').hide();
    }
  }, '.sub-menu-parent');

  $(document).on('click','.mobile-drawer-action-btn',function(){

    const parent = $(this).parent(".mobile-menu-sub-menu-tree-wrap");
    const id = parent.attr('data-id');
    const icon = $(this);

    if(icon.hasClass('fa-chevron-down'))
    {
      $(".mobile-menu-sub-menu-wrap[data-id='"+id+"']").slideDown();
      icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
    }
    else
    {
      $(".mobile-menu-sub-menu-wrap[data-id='"+id+"']").slideUp();
      icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
    }


  });

  $(document).on('click','.mobile-sub-menu-drawer-action-btn',function(){

    const parent = $(this).parent(".mobile-sub-menu-parent");
    const id = parent.attr('data-id');

    $(".mobile-sub-child-menu-wrap[data-id='"+id+"']").toggle();

  });



  function updateCartCaret()
  {
    $.ajax({
      type: 'POST',
      url: '/cart',
      dataType: 'json',
      success: function(data) {
        if(data.item_count > 0)
        {
          $(".cart_top_count").text(data.item_count);
        }
        else
        {
          $(".cart_top_count").text("");
        }
      },
      error: function(err) {
      }
    });
  }

  $(document).on('click','.add_to_cart_btn',function(e){
    e.preventDefault();

    const wrapper = $(this).parents('form');

    let id = wrapper.find('input[name="id"]').val();
    const quantity = wrapper.find('input[name="quantity"]').val();
    const btn = $(this);
    let cart_properties = {};

    if(quantity === 0)
    {
      return false;
    }

    if($('#selected_product_option').length > 0)
    {
      id = $("#selected_product_option").val();
    }

    $("#cart_info_status_wrapper").html("");
    btn.addClass("loading").attr('disabled',true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: id,
        quantity: quantity,
        properties: cart_properties
      },
      dataType: 'json',
      success: function(data) {
        btn.removeClass("loading").attr('disabled',false);
        if(!data.id)
        {
          return;
        }

        updateCartCaret();

        let elem = "<div class='cart_success_info_elem_wrap'><i class='fa-solid fa-circle-check'></i><span>Added to cart</span></div>";
        $("#cart_info_status_wrapper").html(elem);
      },
      error: function(err) {
        btn.removeClass("loading").attr('disabled',false);
        updateCartCaret();

        let elem = "<div class='cart_error_info_elem_wrap'><i class='fa-solid fa-circle-exclamation'></i><span>"+err.responseJSON.description+"</span></div>";
        $("#cart_info_status_wrapper").html(elem);
      }
    });

  });

  $(document).on('click','.main-product-qty-wrapper .main-product-qty-minus',function(){

    const wrapper = $(this).parents('.main-product-qty-wrapper');
    let qty = wrapper.find('#quantity').val();
    qty = parseInt(qty);

    if(qty > 1)
    {
      wrapper.find("#quantity").val(qty - 1);
    }

  });

  $(document).on('click','.main-product-qty-wrapper .main-product-qty-plus',function(){

    const wrapper = $(this).parents('.main-product-qty-wrapper');
    let qty = wrapper.find('#quantity').val();
    qty = parseInt(qty);
    wrapper.find("#quantity").val(qty + 1);

  });

  $(document).on('click','#checkout_btn',function(){

    $("#cart").submit();

  });

  function refreshCart(row_id,message)
  {
    const wrapper = $(".cart_items_container");

    if(wrapper.length === 0)
    {
      return;
    }

    const url = wrapper.attr('data-url');
    $.ajax({
      type: 'GET',
      url: url,
      success: function(data) {
        wrapper.html(data);

        if(typeof message !== "undefined" && typeof row_id !== "undefined")
        {
          $("table.cart-items-table").find("tr[data-id='"+row_id+"']").find(".cart_item_update_error").text(message);
        }
      },
      error: function(err) {
      }
    });
  }

  function updateCartItemQty(id,qty)
  {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: id,
        quantity: qty
      },
      success: function() {
        updateCartCaret();
        refreshCart();
      },
      error: function(err) {
        refreshCart(id,err.responseJSON.message);
      }
    });
  }

  $(document).on('click','.cart-items-table .cart-item-qty-plus',function(){

    const wrapper = $(this).parents('tr');
    const id = wrapper.attr('data-id');
    let qty = wrapper.find('.product_qty_input').val();
    qty = parseInt(qty);
    const new_qty = qty + 1;

    wrapper.find(".product_qty_input").val(new_qty);
    updateCartItemQty(id,new_qty);

  });

  $(document).on('click','.cart-items-table .cart-item-qty-minus',function(){

    const wrapper = $(this).parents('tr');
    const id = wrapper.attr('data-id');
    let qty = wrapper.find('.product_qty_input').val();
    qty = parseInt(qty);

    if(qty > 1)
    {
      const new_qty = qty - 1;

      wrapper.find(".product_qty_input").val(new_qty);
      updateCartItemQty(id,new_qty);
    }

  });

  $(document).on('change','.cart-items-table .product_qty_input',function(){

    const wrapper = $(this).parents('tr');
    const id = wrapper.attr('data-id');
    const new_qty = $(this).val();

    if(new_qty <= 0)
    {
      $(this).val(1);
      return false;
    }

    updateCartItemQty(id,new_qty);
  });

  if($(".swiper").length > 0)
  {
    let swiper = new Swiper('.swiper', {
      direction:'horizontal',
      loop: true,
      autoplay:true,
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

    });
  }

  $(document).on('change','.sort_wrapper #SortBy',function(){

    const selected_type = $(this).val();
    const url = $("#collection_url").val();
    const wrapper = $(".product-grid-container");

    wrapper.addClass("loading");

    $.ajax({
      type: 'GET',
      url: url+"?sort_by="+selected_type,
      success: function(data) {
        wrapper.html($(data).find('.product-grid-container').html());
        wrapper.removeClass("loading");
      },
      error: function(){
        wrapper.removeClass("loading");
      }
    });

  });

  $(document).on('click','#contact-form-submit-btn',function(){

    const btn = $(this);
    $(".contact_form_email_error_wrap").hide();

    const first_name = $("#contact-form-first-name").val();
    const email = $("#contact-form-email").val();
    const phone = $("#contact-form-telephone").val();
    let post_code = $("#contact-form-postcode").val();
    const message = $("#contact-form-message").val();
    
    let last_name = "";
    let address = "";
    let firm_name = "";
    let place = "";
    let product_type = "";

    if(email === "")
    {
      $(".contact_form_email_error_wrap").show();
      return;
    }

    let contactData = {
      'form_type': 'customer',
      'utf8': '✓',
      'contact[name]': first_name,
      'contact[email]': email,
      'contact[note]': first_name+";"+last_name+";"+email+";"+phone+";"+address+";"+post_code+" "+place+";"+message+";"+firm_name+";"+product_type+";"
    };

    btn.attr('disabled',true).css({'opacity':"0.5"});

    $.ajax({
      url: '/contact',
      type: 'POST',
      data: contactData,
      dataType: 'html',
      success: function() {
        btn.attr('disabled',false).css({'opacity':"1"});

        $("#contact-form-widget").hide();
        $(".form_submitted_msg_wrap p").show();
      },
      error: function(xhr) {
        btn.attr('disabled',false).css({'opacity':"1"});

        $("#contact-form-widget").hide();
        $(".form_submitted_msg_wrap p").show();
      }
    });

  });

  $(document).on('click','#header_link_btn',function(e){

    if($(".contact-form-banner-wrapper").length === 0)
    {
      return;
    }

    e.preventDefault();

    $("html, body").animate({
      scrollTop: $(".contact-form-banner-wrapper").offset().top - 100
    }, 500);

  });

  updateCartCaret();
});
